import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    nr: "01",
    title: "Es läuft immer wieder in deinem Kopf ab.",
    text: "Ein Gespräch. Eine Situation. Ein Mensch. Was wurde gesagt? Warum ist es passiert? Was hättest du anders machen können? Obwohl längst alles gesagt ist, geht das Gespräch in deinem Kopf weiter.",
  },
  {
    nr: "02",
    title: "Ein kleiner Auslöser – und plötzlich ist alles wieder da.",
    text: "Ein Lied. Ein Name. Ein Ort. Eine Nachricht. Manchmal reicht ein Gedanke – und du bist emotional wieder mitten in etwas, von dem du dachtest, du hättest es längst hinter dir.",
  },
  {
    nr: "03",
    title: "Und manchmal trägt dein Körper mit.",
    text: "Innere Unruhe. Angespannte Schultern. Ein Knoten im Bauch. Druck im Brustkorb. Es beschäftigt nicht nur deine Gedanken. Es macht etwas mit dir.",
  },
];

export default function Wiedererkennung() {
  return (
    <section data-testid="wiedererkennung-section" className="bg-cream px-6 md:px-14 pt-24 md:pt-32 pb-28 md:pb-36">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <p className="text-xs md:text-sm font-medium uppercase tracking-[0.32em] text-bronze mb-6">
            Vielleicht kennst du dieses Gefühl …
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif tracking-tight text-2xl md:text-4xl leading-snug text-espresso max-w-3xl">
            Nach aussen ist längst alles vorbei.<br />Aber in dir wirkt es noch nach.
          </h2>
        </Reveal>

        <div className="mt-20 md:mt-28 grid md:grid-cols-3 gap-12 md:gap-16 lg:gap-20">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.nr} delay={0.12 * i}>
              <div data-testid={`wiedererkennung-chapter-${c.nr}`} className="border-t border-line pt-10">
                <span className="font-serif italic text-3xl md:text-4xl text-gold/80">{c.nr}</span>
                <h3 className="mt-6 font-serif text-xl md:text-[1.45rem] leading-snug text-espresso tracking-tight">
                  {c.title}
                </h3>
                <p className="mt-5 text-sm md:text-[0.95rem] font-light leading-[1.8] text-taupe">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-16 md:mt-20 font-serif italic text-xl md:text-2xl leading-snug text-espresso tracking-tight max-w-3xl">
            Vielleicht bist du nicht müde, weil du zu wenig Kraft hast.<br />
            Vielleicht bist du müde davon, etwas schon viel zu lange mit dir herumzutragen.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
